<template>
  <el-dialog
    :title="title"
    :visible.sync="state"
    width="1160px"
    :close-on-click-modal="false"
    :show-close="false"
    @open="onVisibleChange(true)"
    @close="onVisibleChange(false)"
  >
    <div class="filter-box" v-if="state">
      <div>
        <el-form label-width="45px" inline v-highlight class="elementui-common-form-styles">
          <el-form-item label="创建人" label-width="62px">
            <ThrottleSelector
              :popper-append-to-body="false"
              v-model="opId"
              @change="newQuery"
              @on-clear="newQuery"
              :list="PTOM_USERS"
              style="width: 127px"
              placeholder="全部"
              filterable
              clearable
            />
          </el-form-item>
          <el-form-item label="平台">
            <el-select style="width: 110px" :value="platform" clearable @change="changePlatform">
              <el-option :value="1" label="安卓"></el-option>
              <el-option :value="2" label="IOS"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="游戏">
            <ThrottleSelector
              :popper-append-to-body="false"
              v-model="gameId"
              @change="newQuery"
              @on-clear="newQuery"
              :list="GAMES"
              style="width: 140px"
              placeholder="全部"
              filterable
              clearable
            />
          </el-form-item>
          <el-form-item label="游戏组" label-width="62px">
            <ThrottleSelector
              :popper-append-to-body="false"
              v-model="groupId"
              @change="newQuery"
              @on-clear="newQuery"
              :list="GAME_GROUPS"
              style="width: 120px"
              placeholder="全部"
              filterable
              clearable
            />
          </el-form-item>
          <el-form-item label-width="0">
            <DateRangePicker
              v-model="datetime"
              :append-to-body="false"
              :clearable="false"
              style="width: 220px"
              @change="sendEvent"
            ></DateRangePicker>
          </el-form-item>
          <slot name="tageting-type"> </slot>

          <el-form-item label-width="0">
            <el-input v-model.trim="keyword" placeholder="定向/计划名称" clearable style="width: 180px" @keyup.enter.native="search">
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </el-form-item>

          <slot name="btn">
            <el-button type="primary" @click="targetAddAction">新建定向</el-button>
          </slot>
        </el-form>
      </div>
    </div>

    <el-table
      ref="table"
      height="430"
      border
      v-loading="loading"
      class="common-el-table-styles"
      :data="data"
      row-key="targetingId"
      @row-click="rowClick"
      @selection-change="onSelectionChange"
      @sort-change="sortTable"
    >
      <el-table-column
        type="selection"
        reserve-selection
        row-key="targetingId"
        width="55"
        :selectable="rowSelectable"
      ></el-table-column>
      <el-table-column prop="targetingName" label="定向名称" min-width="200">
        <template slot-scope="{ row }">
          <!-- <el-popover
            v-if="row.mediaId === 6"
            trigger="hover"
            placement="top-start"
            popper-class="target-tooltip"
            @show="showAudience(row)"
          >
            <div class="targeting-name" slot="reference">
              <a href="javascript: void(0)">{{ row['targetingName'] }}</a>
              <i v-if="!!mediaPath" class="el-icon-edit target-edit" @click="targetEditAction(row)"></i>
            </div>
            <div class="target-wrap">
              <header>
                <dl>{{ row['targetingName'] }}</dl>
                <dl>ID: {{ row['targetingId'] }}</dl>
              </header>
              <div class="target-content">
                <div v-if="ucTargetsLoading" v-loading="true" style="height: 50px"></div>
                <ul v-if="row['targets']">
                  <template v-for="(item, id) in row['targets']">
                    <li v-if="!item.hide" :key="id">
                      <dt>{{ item.name }}：</dt>
                      <dd v-if="item.all">不限</dd>
                      <dd v-else>
                        <span v-for="(ret, i) in item.values" :key="i"> {{ i ? '、' : '' }}{{ ret }} </span>
                      </dd>
                    </li>
                  </template>
                </ul>
                <ul v-else>
                  <template v-for="(item, index) in row['ucTargets']">
                    <li :key="index" v-if="item.isShow">
                      <dt>{{ item.name }}：</dt>
                      <dd>{{ item.value }}</dd>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </el-popover> -->
          <!-- <div v-else class="targeting-name">
            <el-button type="text">{{ row['targetingName'] }}</el-button>
            <i v-if="!!mediaPath" class="el-icon-edit target-edit" @click.stop="targetEditAction(row)"></i>
          </div> -->

          <div class="targeting-name">
            <el-button type="text">{{ row['targetingName'] }}</el-button>
            <i v-if="!!mediaPath" class="el-icon-edit target-edit" @click.stop="targetEditAction(row)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="['tencent', 'toutiao'].includes(mediaPath)"
        :prop="mediaPath === 'toutiao' ? 'targetingTypeLabel' : 'adMarketingScene'"
        label="定向类型"
        :min-width="mediaPath === 'toutiao' ? 110 : 90"
      ></el-table-column>
      <el-table-column
        v-for="(col, index) in formatCol"
        :key="index"
        :prop="col.key"
        :label="col.title"
        :sortable="col.sortable"
        min-width="120"
      >
        <template slot-scope="{ row }">
          <span v-if="['amount'].includes(col.key) || col.key.indexOf('Cost') > -1">
            {{ row[col.key] | toThousands }}
          </span>
          <span v-else-if="col.key.indexOf('Rate') > -1 || col.key.indexOf('Roi') > -1">
            {{ row[col.key] | toPercentFixed }}
          </span>
          <span v-else>{{ row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: right"
      layout="total, prev, pager, next"
      :current-page.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      background
      @current-change="changePageIndex"
      class="page-index"
    />

    <div slot="footer" class="footer-row">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import moment from 'moment'
import columns from './columns.json'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { debounce, isArray, deepCopy } from '@/common/js/utils'
// import { ucCompile } from '@/common/js/ucCompile'
// import uccityData from '@/data/uc/city_province'
// import ucgategoryData from '@/data/uc/app_categroy'
// import ucinterestData from '@/data/uc/interest_data'
// import ucuPlusData from '@/data/uc/uplus_data'
import DateRangePicker from '@/components/date-range-picker'

import { MEDIAS } from '@/common/js/constants.js'
import { getAudience } from '@/api/uc.model'
import { PTOM_USERS, GAMES, GAME_GROUPS, initPageData } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PTOM_USERS, GAMES, GAME_GROUPS])

const mediaTypes = {
  10: 'toutiao',
  16: 'tencent',
  32: 'kuaishou',
  45: 'baidu',
  6: 'UC'
}

export default {
  name: 'targetManage',
  components: { DateRangePicker, ThrottleSelector },
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    openId: {
      type: [Number, String]
    },
    platform: {
      type: [Number, String],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    rowSelectable: {
      type: Function,
      default: () => true
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.defaultData.length
    },
    title() {
      return `定向选择  ${this.len ? '(已选' + this.len + '条)' : ''}`
    },
    params() {
      return {
        createOpId: this.opId === '' ? undefined : this.opId,
        gameId: this.gameId,
        gameGroupId: this.groupId,
        platform: this.platform,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        sort: this.sort,
        order: this.order
      }
    },
    formatCol() {
      const relCol = this.columns.filter((ret) => ret.slot && ret.format)
      return relCol
    },
    mediaPath() {
      // 把数据第一条的媒体id作为对应的定向包路径
      const [row] = this.data
      return row?.mediaId ? mediaTypes[row.mediaId] : ''
    }
  },
  methods: {
    /**
     * @description: 跳转编辑定向包
     * @param {*} row
     * @return {*}
     */
    targetEditAction(row) {
      if (row.mediaId === MEDIAS.TOUTIAO || row.mediaId === MEDIAS.GDT) {
        this.$emit('edit', row)
      } else {
        window.open(`/promote/targeting/${this.mediaPath}?targetingId=${row.targetingId}&t=edit`, '_blank')
      }
    },
    /**
     * @description: 跳转新增定向包
     * @return {*}
     */
    targetAddAction() {
      window.open('/promote/targeting/list', '_blank')
    },

    // showAudience(row) {
    //   return new Promise((resolve, reject) => {
    //     if (row.mediaId === 6 && !row.ucTargets) {
    //       this.ucTargetsLoading = true
    //       getAudience({ ad_account_id: Number(row.accountIds) }).then((ret) => {
    //         if (isArray(ret)) {
    //           this.ucOriginData.audienceData = ret
    //           const json = ucCompile(row.targetingParamJson, this.ucOriginData)
    //           this.$set(row, 'ucTargets', json)
    //           this.ucTargetsLoading = false
    //           resolve(json)
    //         }
    //       })
    //     }
    //   })
    // },
    onVisibleChange(val) {
      if (!val) {
        this.keyword = ''
        this.pageIndex = 1
        this.defaultData = []
      } else {
        this.opId = this.openId
        this.newQuery()
      }
    },
    /**
     * @description: 页码重置后搜索
     * @return {*}
     */
    newQuery() {
      this.$nextTick(() => {
        this.defaultData = []
        this.search()
      })
    },
    sendEvent() {
      let params = JSON.parse(JSON.stringify(this.params))
      params = Object.assign(params, {
        keyword: this.keyword === '' ? undefined : this.keyword,
        pageIndex: this.pageIndex
      })
      this.$emit('on-change', params)
    },
    search() {
      let params = JSON.parse(JSON.stringify(this.params))
      this.pageIndex = 1
      params = Object.assign(params, {
        keyword: this.keyword === '' ? undefined : this.keyword,
        pageIndex: this.pageIndex
      })
      this.$emit('on-search', params)
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.sendEvent()
    },
    changePlatform(val) {
      this.platform = val
      this.$emit('on-platform', val)
    },
    rowClick(row, column, event) {
      if (!this.rowSelectable(row)) return
      this.$refs.table.toggleRowSelection(row)
    },
    toggleCheck(check = false) {
      if (check) {
        this.data.forEach((row) => {
          if (this.rowSelectable(row)) this.$refs.table.toggleRowSelection(row, true)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },
    onSelectionChange(selection) {
      this.defaultData = [...selection]
    },
    sortTable({ column, prop, order }) {
      if (order === null) {
        this.sort = ''
        this.order = ''
      } else {
        this.sort = prop
        this.order = order === 'ascending' ? 'asc' : 'desc'
      }
      this.pageIndex = 1
      this.sendEvent()
    },

    save() {
      if (this.defaultData.length) {
        const targetData = deepCopy(this.defaultData)
        if (this.multiple || (!this.multiple && targetData.length === 1)) {
          this.$emit('on-select', targetData)
          this.state = false
        } else if (targetData.length > 1) this.$message.warning('最多只能选择一个定向包')
      } else this.$message.warning('您未选择一个定向包')

      this.$refs.table.clearSelection()
    },
    cancel() {
      this.$emit('on-cancel')
      this.$refs.table.clearSelection()
    }
  },
  watch: {
    platform(nVal) {
      debounce(() => {
        this.pageIndex = 1
        this.sendEvent()
      }, 500)()
    }
  },
  data() {
    const now = moment().subtract(1, 'days').format('YYYY-MM-DD')
    return {
      opId: '',
      gameId: '',
      groupId: '',
      keyword: '',
      pageIndex: 1,
      pageSize: 20,
      columns: columns,
      defaultData: [],
      datetime: [now, now],
      sort: '',
      order: '',
      ucTargetsLoading: false,
      ucOriginData: {
        // cityData: uccityData,
        // gategoryData: ucgategoryData,
        // interestData: ucinterestData,
        // uPlusData: ucuPlusData,
        // audienceData: []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.targeting-name {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .target-edit {
    cursor: pointer;
  }
}

.target-tooltip {
  position: relative;
  background: #ff6600;

  .target-close {
    position: absolute;
    top: 18px;
    right: 12px;
  }

  .target-wrap {
    width: 280px;

    header {
      width: inherit;
      padding: 8px 0 8px 8px;
      border-bottom: solid 1px #dedede;

      dl {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 1.2;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin: 0;
      }
    }

    .target-content {
      overflow: auto;
      padding: 8px 0 8px 4px;
      width: 100%;
      max-height: 318px;

      ul {
        margin-top: 12px;
        margin-bottom: 0;
      }

      li {
        padding-bottom: 6px;
        display: flex;

        dd,
        dt {
          line-height: 18px;
          display: inline-block;
          margin: 0;
        }

        dt {
          color: #333;
          font-weight: 600;
        }

        dd {
          max-width: 230px;
          word-break: break-all;
          white-space: normal;
          color: #888;
        }
      }
    }
  }
}
.footer-row {
  width: 100%;
  text-align: right;
}
</style>
